<template>
    <div>
      <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('orderresolution_edit')">
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-basket</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
      </Toolbar>
  
      <br />
  
      <div v-if="item" class="table-orderresolution-show">
        <v-simple-table>
          <template slot="default">
            <thead>
              <tr>
                <th>{{ $t('global.field') }}</th>
                <th>{{ $t('global.value') }}</th>
  
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{{ $t('global.name') }}</strong></td>
                <td>
                                      {{ item['name'] }}
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('order.quality') }}</strong></td>
                <td>
                                        {{ item['quality'] }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
  
      <Loading :visible="isLoading" />
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  import Loading from '../../components/Loading';
  import ShowMixin from '../../mixins/ShowMixin';
  import Toolbar from '../../components/Toolbar';
  import AccessMixin from '../../mixins/AccessMixin';
  
  const servicePrefix = 'OrderResolution';
  
  export default {
    name: 'OrderResolutionShow',
    servicePrefix,
    components: {
        Loading,
        Toolbar
    },
    mixins: [ShowMixin,AccessMixin],
    computed: {
      ...mapFields('orderresolution', {
        isLoading: 'isLoading'
      }),
      ...mapGetters('orderresolution', ['find'])
    },
    methods: {
      ...mapActions('orderresolution', {
        deleteItem: 'del',
        reset: 'reset',
        retrieve: 'load'
      })
    }
  };
  </script>
  